import { type FC } from 'react';
import { Button, Group, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { type PayoutTrader } from '~/entities/payout';
import { type ConfigForm, type UpdateTraderConfigRequest } from '../../../../model';
import {
    buildUpdateTraderConfigRequest,
    getAcceptRateLimitMode,
    getConfigWithDefaults,
    validateAcceptRateLimit,
} from '../../../../lib';
import { transformValues } from '../../../../lib/utils';
import { ConfigEditor } from '../ConfigEditor';

interface TraderConfigFormProps {
    fallbackTraderId: string;
    isLoading?: boolean;
    onSubmit: (values: UpdateTraderConfigRequest) => void;
    trader: PayoutTrader;
}

export const TraderConfigForm: FC<TraderConfigFormProps> = ({ fallbackTraderId, isLoading, onSubmit, trader }) => {
    const form = useForm<ConfigForm, UpdateTraderConfigRequest>({
        initialValues: {
            acceptRateLimitMode: getAcceptRateLimitMode(trader.config),
            config: getConfigWithDefaults(trader.config),
            traderId: trader.id ?? { value: fallbackTraderId },
        },
        validate: {
            config: {
                acceptRateLimit: {
                    maxAccepts: validateAcceptRateLimit,
                    windowSeconds: validateAcceptRateLimit,
                },
            },
        },
        transformValues: (values) => transformValues(buildUpdateTraderConfigRequest(values)),
    });

    return (
        <form
            onSubmit={form.onSubmit((values) => {
                onSubmit(values);
                form.resetDirty();
            })}
        >
            <Stack gap='xs'>
                <ConfigEditor
                    form={form}
                    isLoading={isLoading}
                />

                <Group justify='flex-end'>
                    <Button
                        type='submit'
                        disabled={isLoading}
                        loading={isLoading}
                    >
                        Сохранить
                    </Button>
                </Group>
            </Stack>
        </form>
    );
};
